import { apiGet, apiPost } from "./apiClient";

export const COMPANY_SETTINGS_API = "/api/CompanySettings";

function pick(obj, ...keys) {
  for (const key of keys) {
    if (obj != null && obj[key] != null) return obj[key];
  }
  return undefined;
}

export function normalizeCompanySettings(raw) {
  if (!raw || typeof raw !== "object") return null;

  return {
    id: pick(raw, "id", "Id") ?? 0,
    companyName: pick(raw, "companyName", "CompanyName") ?? "",
    companyEmail: pick(raw, "companyEmail", "CompanyEmail") ?? "",
    phoneNumber: pick(raw, "phoneNumber", "PhoneNumber") ?? "",
    whatsAppNumber: pick(raw, "whatsAppNumber", "WhatsAppNumber") ?? "",
    address: pick(raw, "address", "Address") ?? "",
    websiteUrl: pick(raw, "websiteUrl", "WebsiteUrl") ?? "",
    companyLogo: pick(raw, "companyLogo", "CompanyLogo") ?? "",
    facebookUrl: pick(raw, "facebookUrl", "FacebookUrl") ?? "",
    instagramUrl: pick(raw, "instagramUrl", "InstagramUrl") ?? "",
    twitterUrl: pick(raw, "twitterUrl", "TwitterUrl") ?? "",
    linkedInUrl: pick(raw, "linkedInUrl", "LinkedInUrl") ?? "",
    emailAddress: pick(raw, "emailAddress", "EmailAddress") ?? "",
    emailPassword: pick(raw, "emailPassword", "EmailPassword") ?? "",
    hasEmailPassword: Boolean(pick(raw, "hasEmailPassword", "HasEmailPassword")),
    updatedAt: pick(raw, "updatedAt", "UpdatedAt") ?? null
  };
}

export async function fetchCompanySettings() {
  const res = await apiGet(COMPANY_SETTINGS_API);
  if (!res.ok) return res;
  return { ok: true, data: normalizeCompanySettings(res.data) };
}

export async function saveCompanySettings(payload) {
  return apiPost(COMPANY_SETTINGS_API, payload);
}
